import { render, staticRenderFns } from "./u-btn-flat-pill.vue?vue&type=template&id=3c1a056c&scoped=true"
import script from "./u-btn-flat-pill.vue?vue&type=script&lang=js"
export * from "./u-btn-flat-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a056c",
  null
  
)

export default component.exports